import axios from './_nestAxios'

export const obtenerPrimerPendienteEmisor = () => axios.get('/guias-venta-historial/primer-pendiente')

export const obtenerAsEmisor = params =>
  axios.get('/guias-venta-historial', {
    params: {
      ...params,
      tipoConsulta: 'emisor'
    }
  })

export const descargarCdrxId = id => axios.post(`/guias-venta-historial/${id}/descargar-cdr`, {}, { responseType: 'blob' })

export const enviarCorreoXmlxId = id => axios.post(`/guias-venta-historial/${id}/enviar-correo`, {}, { params: { tipoEnvio: 'xml' } })

export const enviarCorreoXmlCdrxId = id => axios.post(`/guias-venta-historial/${id}/enviar-correo`, {}, { params: { tipoEnvio: 'xml-cdr' } })

export const verificarParaBaja = params => axios.post('/guias-venta-historial/verificar-para-baja', params)

export const darDeBajaxId = id => axios.post(`/guias-venta-historial/${id}/dar-de-baja`)

export const enviarDocumentosxIds = data => axios.post('/guias-venta-historial/enviar-documentos', data)
